import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: "ids" },
    handle: { type: String, default: ".sortable-handle" },
    successMessage: { type: String, default: "Order saved" },
    errorMessage: { type: String, default: "Failed to save order" }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: this.handleValue,
      ghostClass: "opacity-50",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const ids = Array.from(this.element.children).map(el => el.dataset.sortableId)

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ [this.paramValue]: ids })
      })

      if (response.ok) {
        this.showNotification(this.successMessageValue, "success")
      } else {
        this.showNotification(this.errorMessageValue, "error")
      }
    } catch (error) {
      console.error("Error saving sort order:", error)
      this.showNotification(this.errorMessageValue, "error")
    }
  }

  showNotification(message, type = "success") {
    const container = document.querySelector(".fixed.top-4.right-4.z-50") || this.createContainer()

    const alertClass = type === "success" ? "alert-success" : "alert-error"
    const iconPath = type === "success"
      ? "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      : "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"

    const alert = document.createElement("div")
    alert.className = `alert ${alertClass} shadow-lg transition-all duration-300`
    alert.setAttribute("data-controller", "flash")
    alert.setAttribute("data-flash-auto-dismiss-value", "3000")
    alert.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="${iconPath}" />
      </svg>
      <span class="flex-1">${message}</span>
      <button type="button" class="btn btn-ghost btn-xs btn-square" data-action="flash#dismiss">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    `

    container.appendChild(alert)
  }

  createContainer() {
    const container = document.createElement("div")
    container.className = "fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm"
    document.body.appendChild(container)
    return container
  }
}
